const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/**
 * Currency formatting via Intl, not hard-coded. When we ship more
 * locales / currencies (post WEB-95) the runtime locale resolution
 * picks up here automatically — replace `'en-US'` with the user
 * preference.
 */
export function formatCurrency(value: number): string {
  return usd.format(value)
}

const monthFormat = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' })

export function formatMonthLabel(year: number, month: number): string {
  // month is 1-indexed; Date uses 0-indexed.
  return monthFormat.format(new Date(year, month - 1, 1))
}

/** Today's (year, month) in 1-indexed form. */
export function currentYearMonth(): { year: number; month: number } {
  const now = new Date()
  return { year: now.getFullYear(), month: now.getMonth() + 1 }
}

/** Step forward/backward by `delta` months. */
export function stepMonth(year: number, month: number, delta: number): { year: number; month: number } {
  const d = new Date(year, month - 1 + delta, 1)
  return { year: d.getFullYear(), month: d.getMonth() + 1 }
}
